/**
 * Created by h.nanev on 6/15/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import Heading from "../heading/Heading";
import ActionMenu from "../action-menu/ActionMenu";
import Action from "../action-menu/Action";
import documentedProps from "./documentation/ModalHeaderDocumentedProps";

export default class ModalHeader extends React.Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
    }

    onClose() {
        this.props.onClose && this.props.onClose();
    }

    render() {
        let extraClasses = this.props.extraClasses || "";
        let className = extraClasses + " tq-modal-header";
        className += this.props.background ? " tq-header-bgr" : "";
        let classes = {
            header: className
        };
        let headerContent;

        if (this.props.children) {
            headerContent = this.props.children;
        } else {
            headerContent = (
                <Heading splitter="light" title={this.props.label} leftIcon={this.props.icon}>
                    {!this.props.hideCloseIcon && (
                        <ActionMenu onSelectItem={this.onClose}>
                            <Action id="close" icon="tq-icon-close" />
                        </ActionMenu>
                    )}
                </Heading>
            );
        }
        return <header className={classes.header}>{headerContent}</header>;
    }
}

ModalHeader.displayName = "ModalHeader";

ModalHeader.propTypes = {
    extraClasses: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
    background: PropTypes.bool,
    hideCloseIcon: PropTypes.bool,
    onClose: PropTypes.func
};

ModalHeader.documentedProps = documentedProps;
